import {Component, inject} from '@angular/core';
import {BaseModalComponent} from "../base-modal/base-modal.component";
import {MatButton} from "@angular/material/button";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {FormsModule} from "@angular/forms";
import {ProfileColumnDialogData} from "./types/profile-column-modal.types";
import {ProfileColumnModalService} from "./services/profile-column-modal.service";
import {profileColumnModalName} from "./configs/profile-column-modal-config";

@Component({
  selector: 'app-profile-column-modal',
  imports: [
    BaseModalComponent,
    MatButton,
    MatFormField,
    MatInput,
    MatLabel,
    FormsModule
  ],
  templateUrl: './profile-column-modal.component.html',
  styleUrl: './profile-column-modal.component.scss'
})
export class ProfileColumnModalComponent extends BaseModalComponent {
  public profileColumnDialogData = inject<ProfileColumnDialogData>(MAT_DIALOG_DATA);
  private profileColumnModalService: ProfileColumnModalService = inject(ProfileColumnModalService);

  public newProfileName: string = '';

  public override ngOnInit(): void {
    super.ngOnInit();
    this.modalStatesService.openModal(profileColumnModalName);
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(profileColumnModalName);
  }

  public handleSaveBtn(): void {
    const columnProfiles = this.profileColumnDialogData.columnProfiles;
    if (!!columnProfiles?.find(i => i === this.newProfileName)?.length) {
      this.errorService.showErrorMessage('Профиля с таким названием уже существует!');
      return;
    }

    this.profileColumnModalService.saveOrUpdateProfile({
      currentProfileName: this.profileColumnDialogData.currentProfileName,
      newProfileName: this.newProfileName
    });

    this.dialogRef.close({ newProfileName: this.newProfileName });
  }
}
